import { useDispatch, useSelector } from "react-redux";
import {
  generateFavouriteAnalyticsType,
  sendAnalyticsEvent,
} from "../lib/postMessage";
import { ADDBET, FAVOURITES } from "../constants/analytics";

const maxSelections = 25;

export default function (selection) {
  const { selections, format } = useSelector((state) => state.betslip);
  const { filters } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const updateBetslip = (bet) => {
    if (
      selection &&
      selections &&
      selections.length >= 0 &&
      selections.length < maxSelections &&
      !selections.some(
        (sel) =>
          sel.id === bet.selection.id && sel.marketId === bet.selection.marketId
      )
    ) {
      dispatch({
        type: "ADD_SELECTION_TO_BETSLIP",
        payload: {
          location: bet.location,
          id: bet.selection.id,
          marketId: bet.selection.marketId,
          bet, // for the postMessage data
        },
      });
      if (filters.favourites.markets || filters.favourites.odds) {
        sendAnalyticsEvent({
          event: FAVOURITES,
          type: generateFavouriteAnalyticsType(filters.favourites),
          action: ADDBET,
        });
      }
    }
    if (
      selection &&
      selections.length > 0 &&
      selections.length <= maxSelections &&
      selections.some(
        (sel) =>
          sel.id === bet.selection.id && sel.marketId === bet.selection.marketId
      )
    ) {
      dispatch({
        type: "REMOVE_SELECTION_FROM_BETSLIP",
        payload: {
          location: bet.location,
          id: bet.selection.id,
          marketId: bet.selection.marketId,
        },
      });
    }
  };

  let isActive = false;

  if (selection) {
    isActive =
      selections &&
      selections.length > 0 &&
      selections.length <= maxSelections &&
      selections.some(
        (sel) => sel.id === selection.id && sel.marketId === selection.marketId
      );
  }

  const oddsFormat = format ? format : "Fractional";

  return [isActive, updateBetslip, oddsFormat];
}
